export const FETCH_LOGS_START = 'FETCH_LOGS_START';
export const FETCH_LOGS_SUCCESS = 'FETCH_LOGS_SUCCESS';
export const FETCH_LOGS_FAIL = 'FETCH_LOGS_FAIL';
